<template>
    <div class="row">
                <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">
                    <!--- rechts // small -> oben --->
                    <div class="card card-profile shadow">
                        <div class="row justify-content-center">
                        </div>
                        <div class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                            <h3>Informationen</h3>

                        </div>
                        <div v-if="report.location !== null" class="card-body pt-0 pt-md-4">
                            <div class="row">
                                <div v-if="!isLoading" class="col">
                                    <p>Standort: <router-link :to="'/locations/edit/'+report.location.id">{{report.location.name}}</router-link><br>
                                        Erstellungsdatum: {{report.createdAt|formatDateToDay}}</p>

                                    <p><strong>Zeitraum</strong><br>
                                    von: {{report.periodStartsAt|formatDateToDay}}<br>
                                    bis: {{report.periodEndsAt|formatDateToDay}}</p>

                                    <p>Empfänger (Behörde): {{report.location.reportingTargetName}} ({{report.location.reportingTargetMail}}) </p>

                                    <p v-if="isAdmin">
                                        Kunde: <router-link :to="'/customer/edit/'+report.customer.id">{{report.customer.name}}</router-link>
                                    </p>
                                </div>
                            </div>
                            <div class="text-center">
                                <a :href="reportblob" class="btn btn-icon my-4 btn-primary" :download="'report'+report.id+'.pdf'">Download PDF</a>
                                <base-button type="success" v-if="report.status === 'sent'" v-on:click="sendModal = true" :disabled="approveLoading" :icon="(approveLoading) ? 'fas fa-spinner fa-pulse' : 'fas fa-file-alt'">Gesendet am {{report.sentAt | formatDate}}</base-button>
                                <base-button type="warning" v-else v-on:click="sendModal = true" :disabled="approveLoading" :icon="(approveLoading) ? 'fas fa-spinner fa-pulse' : 'fas fa-file-alt'">Bericht an Empfänger senden</base-button>


                                <!---- BEGINN MODAL ----->

                                <modal :show.sync="sendModal"
                                       gradient="danger"
                                       modal-classes="modal-danger modal-dialog-centered">
                                    <h6 slot="header" class="modal-title" id="modal-title-notification">Bitte bestätigen Sie den Versand der Berichts</h6>

                                    <div class="py-3 text-center" v-if="report.status === 'sent'" >
                                        <i class="ni ni-bell-55 ni-3x"></i>
                                        <h4 class="heading mt-4">Sie haben den Bericht bereits versendet</h4>
                                        <p>Sie haben den Bericht bereits am {{report.sentAt | formatDate}} versendet. Sie können den Bericht allerdings durch einen erneuten Klick auf den grünen Button noch einmal versenden.</p>
                                        <p>Empfänger (Behörde): {{report.location.reportingTargetName}} ({{report.location.reportingTargetMail}}) </p>
                                    </div>

                                    <div class="py-3 text-center" v-else>
                                        <i class="ni ni-bell-55 ni-3x"></i>
                                        <h4 class="heading mt-4">Nur noch ein Klick!</h4>
                                        <p>Haben Sie den Bericht gelesen und sind bereit diesen an die zuständige Behörde zu versenden?</p>
                                        <p>Empfänger (Behörde): {{report.location.reportingTargetName}} ({{report.location.reportingTargetMail}}) </p>

                                        <base-input placeholder="Betreff" label="Betreff" label-classes="text-white" v-model="mail.subject"></base-input>
                                        <base-input placeholder="Antwort an" label="Antwort an" label-classes="text-white" v-model="mail.replyto"></base-input>

                                        <textarea class="form-control form-control-alternative" rows="5" placeholder="Emailtext" v-model="mail.message"></textarea>

                                    </div>


                                    <template slot="footer">
                                        <base-button type="success" v-if="report.status === 'sent'" v-on:click="approveReport(report.id)" :disabled="approveLoading" :icon="(approveLoading) ? 'fas fa-spinner fa-pulse' : 'fas fa-file-alt'">Gesendet am {{report.sentAt | formatDate}}</base-button>
                                        <base-button type="white" v-else v-on:click="approveReport(report.id)" :disabled="approveLoading" :icon="(approveLoading) ? 'fas fa-spinner fa-pulse' : 'fas fa-file-alt'">Ja, Bericht an Behörde senden</base-button>
                                        <base-button type="link"
                                                     text-color="white"
                                                     class="ml-auto"
                                                     @click="sendModal = false">
                                            Nein, nicht versenden
                                        </base-button>
                                    </template>
                                </modal>

                                <!---- END MODAL ------->

                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-8 order-xl-1">
                    <!--- links --->
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Bericht</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            <div v-if="report.status === 'creation'"><i class="fas fa-sync-alt fa-spin"></i> Der Bericht wird gerade erstellt. Dies kann einige Minuten dauern. <br><br><span class="text-muted text-sm">Sollte das Erstellen länger als 60 Minuten dauern, reduzieren Sie bitte die Datenmenge auf max. 2 Jahre. Sollte dies nicht reichen, kontaktieren Sie bitte unseren Support.</span></div>
                            <div v-else-if="report.status === 'error'">Es hat ein Problem bei der Erstellung des Berichts gegeben.</div>

                            <b-embed
                                    v-if="!isLoading && report.status !== 'creation' && report.status !== 'error'"
                                    type="iframe"
                                    aspect="4by3"
                                    :src="reportblob"
                                    allowfullscreen
                            ></b-embed>
                            <div v-if="isLoading"><i class="fas fa-circle-notch fa-spin"></i> Loading Report....</div>
                        </template>
                    </card>
                </div>
    </div>
</template>

<script>

    import axios from 'axios';

    export default {
        name: "edit",
        data() {
            return {
                url: '',
                head: {},
                isLoading: false,
                approveLoading: false,
                sendModal: false,
                report: {
                    id: 0,
                    periodStartsAt: null,
                    periodEndsAt: null,
                    status: '',
                    location: null,
                    createdAt: null,
                    customer: null,
                    publicPath: '',
                },
                mail: {
                    subject: '',
                    message: '',
                    replyto: ''
                },
                status: {
                    type: '',
                    msg: ''
                }
            }
        },
        created() {
            this.loading = true;
            this.showReport(this.$route.params.id).then(response => {
                this.head = this.authHeader();
                this.head['Accept'] = 'application/octet-stream';
                this.report = response;
                this.mail.subject = 'Abgabe Dokumenation Sozialkonzept für '+response.location.name;
                this.mail.message = 'Sehr geehrte Damen und Herren,\num den Verpflichtungen des Glücksspielstaatsvertrages bezüglich der Dokumentation der Sozialkonzeptmaßnahmen gerecht zu werden, reichen wir hiermit die Dokumentation für den Standort '+response.location.name+', '+response.location.street+' in '+response.location.postalcode+' '+response.location.city+' für den Zeitraum '+this.$options.filters.formatDateToDay(response.periodStartsAt)+' bis '+this.$options.filters.formatDateToDay(response.periodEndsAt)+' ein.';
                this.mail.replyto = this.$store.getters['authentication/email'];
                axios({
                    url: this.reporturl,
                    headers: this.head,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    this.url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
                    this.$store.dispatch('alert/clear');
                }, (error) => {
                    this.$store.dispatch('alert/error',error);
                })});



        },
        computed: {
            reporturl(){
                return process.env.VUE_APP_API_SERVER + this.report.publicPath;
            },
            reportblob(){
                return this.url;
            }
        },
        methods: {
            showReport(id) {
                return new Promise((resolve) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/reports/`+id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.isLoading = false;
                                resolve(response);
                            },
                            error => {
                                this.isLoading = false;
                                this.$store.dispatch('alert/error',error);
                            });
                });
            },
            approveReport(id) {
                this.sendModal = false;
                return new Promise(() => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: JSON.stringify(this.mail)
                    };
                    this.approveLoading  = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/report/approve/`+id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.approveLoading  = false;
                                this.report = response;
                                this.$store.dispatch('alert/success','Bericht erfolgreich verschickt.')
                            },
                            error => {
                                this.approveLoading  = false;
                                this.$store.dispatch('alert/error',error);
                                this.status =  {type: 'danger', msg: error};
                            });
                });
            },
            editLocation(id) {
                return new Promise(() => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/merge-patch+json';
                    let senddata = this.$refs.LForm.location;
                    senddata.tourintervall = parseInt(senddata.tourintervall);
                    const requestOptions = {
                        method: 'PATCH',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/locations/`+id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.isLoading = false;
                                this.status =  {type: 'success', msg: 'Standort '+response.name+' (ID: '+response.id+') wurde editiert.'};
                            },
                            error => {
                                this.isLoading = false;
                                this.status =  {type: 'danger', msg: error};
                            });
                });
            },
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            }
        }
    }
</script>

<style scoped>

</style>